/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validators_Hex_Color_ErrorInputs */

const en_validators_hex_color_error = /** @type {(inputs: Validators_Hex_Color_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter a valid hex color. (e.g. #FF5733)`)
};

const de_validators_hex_color_error = /** @type {(inputs: Validators_Hex_Color_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte geben Sie eine gültige Hex-Farbe ein. (z.B. #FF5733)`)
};

/**
* | output |
* | --- |
* | "Please enter a valid hex color. (e.g. #FF5733)" |
*
* @param {Validators_Hex_Color_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const validators_hex_color_error = /** @type {((inputs?: Validators_Hex_Color_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validators_Hex_Color_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_validators_hex_color_error(inputs)
	return de_validators_hex_color_error(inputs)
});